module.exports = __webpack_public_path__ + "static/olive-82de811f338bac5be242a5ff204fe5f0.jpg";